document.addEventListener('DOMContentLoaded', function() {
  const productCards = document.querySelectorAll('.product-card-carousel');
  
  productCards.forEach(card => {
    const mainImg = card.querySelector('.carousel-main-img');
    const thumbnails = card.querySelectorAll('.carousel-thumbnail');
    const leftArrow = card.querySelector('.carousel-arrow-left');
    const rightArrow = card.querySelector('.carousel-arrow-right');
    
    if (!thumbnails.length || thumbnails.length <= 1) return;
    
    let currentIndex = 0;
    const maxIndex = thumbnails.length - 1;
    
    function updateImage(index) {
      currentIndex = index;
      
      // Update main image
      const thumbnail = thumbnails[index];
      mainImg.src = thumbnail.src.replace('width=120', 'width=533');
      
      // Update active thumbnail
      thumbnails.forEach(t => t.classList.remove('active'));
      thumbnail.classList.add('active');
      
      // Update arrow states
      leftArrow.disabled = currentIndex === 0;
      rightArrow.disabled = currentIndex === maxIndex;
    }
    
    // Thumbnail clicks
    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        updateImage(index);
      });
    });
    
    // Arrow clicks
    leftArrow.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (currentIndex > 0) {
        updateImage(currentIndex - 1);
      }
    });
    
    rightArrow.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (currentIndex < maxIndex) {
        updateImage(currentIndex + 1);
      }
    });
    
    // Initialize
    updateImage(0);
  });
});